import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import { colorVariables } from "desktop/theme/variables";

import { ReactComponent as PlayIcon } from 'desktop/assets/icons/play.svg';

import {
  ProgramStyled,
  RightPart,
  LeftPart,
  Current,
  RecordWrap,
  Time,
  LastWordWrap,
  TitleWrap,
  StyledTime,
  StyledTitle,
  StyledIcon,
  ProgramLockIcon,
} from "./styles/ProgramStyled";

class Program extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.timeout = undefined;
  }

  componentDidMount() {
    this.props.onInstance(this.props.index, this);
  }

  componentWillUnmount() {
    this.props.onInstance(this.props.index, null);
  }

  onClickProgram = () => {
    const {
      playing,
      singleProgram,
      switchProgram,
      isUIRestricted,
      onRestrictedUIClick,
      toggleExpand,
      getMessageModeData,
    } = this.props;

    if (isUIRestricted && !singleProgram.channel.isLocked) {
      const messageModeData = getMessageModeData();
      if (messageModeData === true) {
        // if there is some stub that is not a 'ui restrcited stub'
        // when 'ui restricted stub' is displayed, messageModeData is {restrictedUIStub: true}
        toggleExpand();
      } else {
        const isNotLiveProgram = singleProgram.state !== 1; // program from the future or past
        onRestrictedUIClick(isNotLiveProgram);
      }
    } else {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
        if (!playing) {
          toggleExpand();
          switchProgram(singleProgram, true);
        }
      } else {
        this.timeout = setTimeout(() => {
          switchProgram(singleProgram, true);
          clearTimeout(this.timeout);
          this.timeout = undefined;
        }, 200);
      }
    }
  };

  render() {
    const {
      time,
      title,
      available,
      playing,
      ended,
      current,
      id,
      style,
      index,
      isInteractive,
      isUIRestricted,
    } = this.props;
    const date = new Date(id * 1000);
    let programTitle = title;
    let lastWord = null;

    if (available) {
      const lastSpace = programTitle.lastIndexOf(" ");
      if (lastSpace !== -1) {
        lastWord = title.substring(lastSpace + 1, title.length);
        programTitle = title.substring(0, lastSpace);
      }
    }

    return (
      <ProgramStyled
        onClick={available ? this.onClickProgram : null}
        id={id}
        style={style}
        data-name="program"
        data-day={date.getDate()}
        data-month={date.getMonth()}
        data-index={index}
        available={available}
      >
        <LeftPart>
          {current ? <Current /> : isUIRestricted ? <ProgramLockIcon /> : null}
          <Time>
            <StyledTime
              currentLineal={!isInteractive && current}
              playing={playing}
              available={available}
              color={colorVariables.gray_darksmoke}
              size="fs_l"
              ended={ended}
            >
              {time}
            </StyledTime>
          </Time>
        </LeftPart>
        <RightPart>
          <TitleWrap>
            <StyledTitle
              currentLineal={!isInteractive && current}
              playing={playing}
              available={available}
              size="fs_l"
              ended={ended}
            >
              {programTitle}
              {lastWord && <Fragment>&nbsp;</Fragment>}
              {available && (
                <LastWordWrap>
                  {lastWord}
                  <RecordWrap available={available}>
                    <StyledIcon
                      available={available}
                      icon={PlayIcon}
                      size={16}
                      viewBox={'0 0 24 24'}
                      color={colorVariables.orange}
                    />
                  </RecordWrap>
                </LastWordWrap>
              )}
            </StyledTitle>
          </TitleWrap>
        </RightPart>
      </ProgramStyled>
    );
  }
}

Program.propTypes = {
  time: PropTypes.string.isRequired,
  title: PropTypes.string,
  ended: PropTypes.bool,
  available: PropTypes.bool,
  playing: PropTypes.bool,
  current: PropTypes.bool,
  switchProgram: PropTypes.func,
  singleProgram: PropTypes.object,
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  onInstance: PropTypes.func.isRequired,
  toggleExpand: PropTypes.func,
  isInteractive: PropTypes.bool,
  isUIRestricted: PropTypes.bool.isRequired,
  onRestrictedUIClick: PropTypes.func.isRequired,
  getMessageModeData: PropTypes.func.isRequired,
};

Program.defaultProps = {
  title: "",
  available: false,
  playing: false,
  ended: false,
  current: false,
  switchProgram: Function.prototype,
  singleProgram: {},
  toggleExpand: Function.prototype,
  isInteractive: false,
};

export default Program;
